import { FormProps } from "antd";
import { PropsWithChildren } from "react";
import { StyledForm } from "./atom";

export function Form({
  className = "",
  size = "large",
  ...props
}: PropsWithChildren<FormProps>) {
  return (
    <StyledForm
      className={`renderbus-ui--form ${className}`}
      size={size}
      {...props}
    />
  );
}

Form.useForm = StyledForm.useForm;
Form.List = StyledForm.List;
Form.ErrorList = StyledForm.ErrorList;
Form.Provider = StyledForm.Provider;
Form.Item = StyledForm.Item;
